<div class="d-flex">
  <div class="header flex-fill" [class.bg-transparent]='theme === "transparent"' [class.bg-light]='theme === "light"'>
    <ng-content></ng-content>
  </div>
</div>